import React from 'react'
import { CardMedia } from '@material-ui/core'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'
import { grey } from '@material-ui/core/colors'




function StoryImageAsset(props) {
  const { asset } = props
  const annotations = asset.annotations
    .map(a =>
      (<CardContent key={a._id}>
        <Typography variant="body1"  style={{ color: grey[900] }} component="p">
          {a.text}
        </Typography>
      </CardContent>))

  const storyImage = {
    width: '100%',
    height: 'auto',
  }

  return (
    <li
      style={{
        listStyleType: 'none',
        margin: '0 0',
        padding: '0 0',
      }}
    >
      <CardMedia >
        <img
        alt={''}
        style={storyImage}
        src={asset.link}
        />
      </CardMedia>
      <CardContent>
        <Typography variant="caption" color="textSecondary" component="p">
          { asset.caption }
        </Typography>
      </CardContent>
      { annotations }
    </li>
  )
}

export default StoryImageAsset
